import { FileViewerDialog } from 'Components';
import { useDocumentUploadContext } from '../../../../../Context/DocumentUploadContext';

export const FilePreviewModal = () => {
  const { showPreviewModal, previewFile, handleClosePreview } =
    useDocumentUploadContext();

  if (!previewFile) return null;

  return (
    <FileViewerDialog
      showDialog={showPreviewModal}
      onClose={handleClosePreview}
      base64={previewFile.base64}
      fileExtension={previewFile.fileExtension}
      fileName={previewFile.fileName}
      title={previewFile.fileName}
      showDownload={false}
      showZoom
      maxDialogWidth={{ xs: 'calc(100% - 32px)', sm: '560px' }}
      maxDialogHeight={{ xs: '85vh', sm: '80vh' }}
    />
  );
};
